export default __webpack_public_path__ + "static/media/background.a6a59b0c.png";